import React from 'react';
import { Faq } from '@beef/smart-kit';
import PropTypes from 'prop-types';
import { FaqHOC } from "../../blocks/hoc/FaqHOC";
var FAQListComponent = function FAQListComponent(_ref) {
  var categories = _ref.categories,
    items = _ref.items,
    onClick = _ref.onClick,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    id: "FAQ-section",
    "data-t-id": "components-FAQList"
  }, /*#__PURE__*/React.createElement(Faq, {
    categories: categories,
    data: items,
    onClick: onClick,
    title: title
  }));
};
FAQListComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string
  })),
  items: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string
    })),
    id: PropTypes.number,
    title: PropTypes.string
  })),
  onClick: PropTypes.func,
  title: PropTypes.string
} : {};
export var FAQList = function FAQList(props) {
  return /*#__PURE__*/React.createElement(FaqHOC, props, /*#__PURE__*/React.createElement(FAQListComponent, {
    "data-t-id": "components-FAQList"
  }));
};